// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nav_button[data-v-bb527cee]{align-items:center;color:#fff;display:flex;height:var(--cosmic-top-nav-bar-height);justify-content:center;width:var(--cosmic-top-nav-bar-height);&[data-v-bb527cee]:focus-visible,&[data-v-bb527cee]:hover{background:var(--cosmic-gray-lighten-3);color:var(--cosmic-text)}&.width_auto[data-v-bb527cee]{width:auto}}", ""]);
// Exports
module.exports = exports;
